import React from 'react';
import { FiUsers } from 'react-icons/fi';
import axios from 'axios';

const TeamMemberSelector = ({ members = [], selectedMember, onMemberSelect }) => {
  const getAvatarUrl = (avatarPath) => {
    if (!avatarPath) return null;

    if (avatarPath.startsWith('http')) {
      return avatarPath;
    } else if (avatarPath.startsWith('/uploads/')) {
      return `${axios.defaults.baseURL}${avatarPath}`;
    } else if (avatarPath.includes('/uploads/')) {
      const uploadPath = avatarPath.substring(avatarPath.indexOf('/uploads/'));
      return `${axios.defaults.baseURL}${uploadPath}`;
    }

    return `${axios.defaults.baseURL}${avatarPath}`;
  };

  return (
    <div className="space-y-1">
      {Array.isArray(members) && members.map((member) => (
        <button
          key={member.id}
          onClick={() => onMemberSelect(member)}
          className={`w-full text-left p-2 rounded-md transition-colors ${
            selectedMember?.id === member.id
              ? 'bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800'
              : 'bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 border border-transparent'
          }`}
        >
          <div className="flex items-center gap-2">
            {member.avatar ? (
              <img
                src={getAvatarUrl(member.avatar)}
                alt={`${member.firstName} ${member.lastName}`}
                className="w-7 h-7 rounded-full object-cover flex-shrink-0"
              />
            ) : (
              <div className="w-7 h-7 bg-primary-500 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-white text-xs font-semibold">
                  {member.firstName?.charAt(0)}{member.lastName?.charAt(0)}
                </span>
              </div>
            )}
            <div className="flex-1 min-w-0">
              <h4 className="font-medium text-sm text-gray-900 dark:text-white truncate">
                {member.firstName} {member.lastName}
              </h4>
              <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate">
                {member.email}
              </p>
            </div>
            <span className={`flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded-full font-medium ${
              member.role === 'team_admin'
                ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
            }`}>
              {member.role === 'team_admin' ? 'Admin' : 'Member'}
            </span>
          </div>
        </button>
      ))}

      {members.length === 0 && (
        <div className="text-center py-3">
          <FiUsers className="w-6 h-6 text-gray-400 mx-auto mb-1" />
          <p className="text-xs text-gray-500 dark:text-gray-400">
            No team members found
          </p>
        </div>
      )}
    </div>
  );
};

export default TeamMemberSelector;
